/* eslint-disable no-prototype-builtins */
/* eslint-disable react/no-array-index-key */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable max-len */
/* eslint-disable react/button-has-type */
import React, {
    useState, useEffect, useCallback, useContext,
} from 'react';
import { distributorService } from '../../service/distributor.service';
import Pagination from '../../Components/Pagination';
import HeaderContext from '../../Components/Context/HeaderContext';
import { PriceHandler } from '../../redux/helper/CamelCase';
import IndentListSkeleton from '../MISReports/IndentReport/indentlistSkeleton';
import EmptyScreen from '../../Components/GlobalEmplyPage';

function ProductPriceList() {
    const [dropdown, setdropdown] = useState(false);
    const [exportDropdown, setExportDropdown] = useState(false);
    const [priceList, setPriceList] = useState([]);
    const [products, setProducts] = useState([]);
    const [filter, setFilter] = useState({});
    const [currentPage, setCurrentPage] = useState(1);
    const [filterQuery, setFilterQuery] = useState({ page: 1, limit: 8 });
    const [totalPage, setTotalPage] = useState('');
    const [alldata, setalldata] = useState({});
    const [loading, setLoading] = useState(true);
    const [emptyData, setEmptyData] = useState(false);

    const {
        SetSuccessMessage,
    } = useContext(HeaderContext);

    const handleFetch = useCallback((query) => {
        distributorService.PriceList(query).then((res) => {
            if (res.data.data.success_status) {
                if (res.data.data.hasOwnProperty('url')) {
                    setLoading(false);
                    SetSuccessMessage('Export successful');
                    delete filterQuery.export;
                    window.open(res.data.data.url, '_blank');
                    setTimeout(() => {
                        SetSuccessMessage('');
                    }, 2000);
                } else if (res.data.data.data.length === 0) {
                    setLoading(false);
                    setEmptyData(true);
                } else {
                    setEmptyData(false);
                    setPriceList(res.data.data.price_list);
                    setProducts(res.data.data.data);
                    setalldata(res.data.data.data);
                    setCurrentPage(res.data.data.current_page);
                    setTotalPage(res.data.data.number_of_pages);
                    setLoading(false);
                }
            }
        });
    }, []);

    const handleFilter = (value, key) => {
        filter[key] = value;
        setFilter(filter);
        if (['category', 'search', 'page', 'export'].includes(key)) {
            filterQuery[key] = value;
        } else {
            filterQuery[key] = value.NAME;
        }
        if (key === 'search') {
            filterQuery.page = 1;
        }
        setFilterQuery(filterQuery);
        handleFetch(filterQuery);
    };

    const handlePageClick = async (data) => {
        const page = data.selected + 1;
        setCurrentPage(page);
        handleFilter(page, 'page');
    };

    useEffect(() => {
        handleFetch(filterQuery);
    }, []);

    const handleClear = async () => {
        setFilterQuery({ page: 1, limit: 8 });
        setFilter({ page: 1, limit: 8 });
        handleFetch({ page: 1, limit: 8 });
    };
    return (
        <div className="py-6 main-screen">
            <div className="flex justify-between items-center pb-[18px]">
                <h5 className="text-xs4 font-normal text-[#555259]">Product Price List</h5>
                <div className="flex items-center justify-between">
                    <div className="mr-[6px]">
                        <div className="dropdown relative">
                            <button
                                id="spacial1"
                                data-bs-toggle="dropdown"
                                aria-expanded="false"
                                className="dropdown-to h-[35px] pl-2 pr-9 shadow  rounded-lg outline-0 border border-[#777777] bg-[#FFFFFF] text-f2 font-normal text-[#A5A5A5] "
                                onClick={() => setdropdown(!dropdown)}
                            >
                                {filter.price_list !== undefined ? <p className="font-normal text-[#090406]">{filter.price_list.NAME}</p> : 'Select product price list'}
                                <img src="/images/sorticon-product-list.svg" alt="icon" className="absolute top-[15px] right-[12px]" />
                            </button>

                            <ul className={`dropdown-menu product-price  w-full absolute ${dropdown ? 'show' : 'hidden'} bg-[#FFFFFF]  rounded-lg  border border-t-0 shadow-s15  z-[40]`} aria-labelledby="special1">
                                {priceList && priceList.map((price) => (
                                    <li className="pl-3.5 w-full pt-2 bg-[#ffffff]">
                                        <a className="dropdown-item text-sm37 font-normal text-[#090406] w-full inline-block territory-inp" href="#" onClick={() => { handleFilter(price, 'price_list'); setdropdown(false); }}>{price.NAME}</a>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    </div>
                    <div className="relative mr-2">
                        <label htmlFor="search" />
                        <input
                            type="text"
                            name="search"
                            id="search"
                            value={filter.search !== undefined ? filter.search : ''}
                            className="w-[235px] h-[35px] bg-[#FFFFFF] rounded-lg outline-0 shadow-s3 text-xs2 font-semibold text-[#808285] placeholder:font-semibold placeholder:text-xs2 placeholder:text-[#808285] pl-[35px]"
                            placeholder="Search"
                            onInput={(e) => handleFilter(e.target.value, 'search')}
                        />
                        <img src="/images/Group-279.svg" alt="icon" className="absolute top-3 left-[15px] cursor-pointer" />
                    </div>
                    <div className="mr-2 dropdown relative">
                        <button onClick={() => handleClear()} type="button" id="exportDropdown" data-bs-toggle="dropdown" aria-expanded="false" className="dropdown-toggle h-[35px] text-xs2 font-semibold text-[#555259] w-[107px] border border-[#555259] rounded-lg">
                            Clear Filter
                        </button>
                    </div>
                    <div className="mr-2 dropdown relative">
                        <button type="button" id="exportDropdown" data-bs-toggle="dropdown" aria-expanded="false" className="dropdown-toggle h-[35px] text-xs2 font-semibold text-[#555259] w-[107px] border border-[#555259] rounded-lg" onClick={() => setExportDropdown(!exportDropdown)}>
                            Export
                        </button>
                        <ul className={`dropdown-menu sm:min-w-[110px] min-w-[110px] absolute ${exportDropdown === true ? '' : 'hidden'} bg-[#FFFFFF] rounded-lg shadow-s2 z-[40] sm:p-3.5 p-1.5`} aria-labelledby="exportDropdown">
                            <li className=" sm:py-1 py-0.5 export border-b border-[#D8D8D8]">
                                <a className="dropdown-item sm:text-xs5 text-sm font-normal text-[#555259] w-full inline-block px-1.5 py-0.5 text-center" href="#" onClick={() => { handleFilter('csv', 'export'); setExportDropdown(false); }}>CSV</a>
                            </li>
                            <li className=" sm:py-1 py-0.5 border-b border-[#D8D8D8]">
                                <a className="dropdown-item sm:text-xs5 text-sm font-normal text-[#555259] w-full inline-block px-1.5 py-0.5 text-center" href="#" onClick={() => { handleFilter('pdf', 'export'); setExportDropdown(false); }}>PDF</a>
                            </li>
                            <li className=" sm:py-1 py-0.5">
                                <a className="dropdown-item sm:text-xs5 text-sm font-normal text-[#555259] w-full inline-block px-1.5 py-0.5 text-center" href="#" onClick={() => { handleFilter('excel', 'export'); setExportDropdown(false); }}>Excel</a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            {loading ? <IndentListSkeleton /> : (
                <div>
                    {products.length > 0 && (
                        <div
                            className="overflow-auto dropdown-menu pb-7 relative z-10"
                            style={{ height: 'calc(100vh - 298px)' }}
                        >
                            <table className="w-full table-auto relative">
                                <thead className="sticky top-0 left-0 z-[2]">
                                    <tr className="bg-[#555259] h-10">
                                        <th className="py-[5px] px-6 rounded-bl-lg rounded-tl-lg min-w-[171px] sticky top-0 left-0 bg-[#555259]" scope="col">
                                            <span className="text-xs5 font-bold text-[#FFFFFF]">
                                                Product Code
                                            </span>
                                        </th>
                                        <th scope="col" className="py-[5px] px-7 min-w-[500px]">
                                            <span className="text-xs5 font-bold text-[#FFFFFF] flex items-center justify-start">
                                                Product Name
                                            </span>
                                        </th>
                                        <th scope="col" className="py-[5px] px-7 min-w-[160px]">
                                            <span className="text-xs5 font-bold text-[#FFFFFF] flex items-center justify-start">
                                                Size
                                            </span>
                                        </th>
                                        <th scope="col" className="py-[5px] px-7 min-w-[200px] text-center">
                                            <span className="text-xs5 font-bold text-[#FFFFFF] flex items-center justify-start">
                                                UoM
                                            </span>
                                        </th>
                                        <th scope="col" className="py-[5px] px-7 min-w-[160px]">
                                            <span className="text-xs5 font-bold text-[#FFFFFF] flex items-center justify-center">
                                                Price
                                            </span>
                                        </th>
                                        <th scope="col" className="py-[5px] px-7 min-w-[188px]">
                                            <span className="text-xs5 font-bold text-[#FFFFFF] flex items-center justify-start">
                                                Category
                                            </span>
                                        </th>
                                        <th scope="col" className="py-[5px] px-7 min-w-[170px]">
                                            <span className="text-xs5 font-bold text-[#FFFFFF] flex items-center justify-start">
                                                Sub-category
                                            </span>
                                        </th>
                                        <th scope="col" className="py-[5px] px-7 min-w-[200px]">
                                            <span className="text-xs5 font-bold text-[#FFFFFF] flex items-center justify-start">
                                                Segment 1
                                            </span>
                                        </th>
                                        <th scope="col" className="py-[5px] px-7 min-w-[200px]">
                                            <span className="text-xs5 font-bold text-[#FFFFFF] flex items-center justify-start">
                                                Segment 2
                                            </span>
                                        </th>
                                        <th scope="col" className="py-[5px] px-7 min-w-[180px] rounded-tr-lg rounded-br-lg">
                                            <span className="text-xs5 font-bold text-[#FFFFFF] flex items-center justify-start">
                                                AWS Classification
                                            </span>
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {products.length > 0 && products.map((prod, prodId) => (
                                        <tr className="bg-[#FDFDFE] border-b border-[#DFEAF7]" key={`price-${prodId}`}>
                                            <td
                                                className="text-sm font-normal text-[#090406] py-4 px-7 sticky top-0 left-0 text-center"
                                                style={{ background: ' rgba(255, 255, 255, 0.45)', backdropFilter: ' blur(5.5px)', zIndex: '1' }}
                                            >
                                                {prod.CONCATENATED_SEGMENTS}
                                            </td>
                                            <td className="text-sm font-normal text-[#090406] px-7 my-4">
                                                <span className="more-lines" data-tooltip-target="tooltip-information" data-tooltip-placement="bottom" data-tooltip-trigger="hover" type="button">
                                                    {prod.DESCRIPTION}
                                                </span>
                                                <div id="tooltip-information" role="tooltip" className="inline-block absolute top-[10px] invisible z-10 sm:pt-4 pt-2.5 sm:px-5 px-2.5 sm:pb-3 pb-2 bg-white rounded-lg shadow-s11 sm:w-[500px] w-[320px]">
                                                    <p className="sm:text-sm63 text-sm46 font-normal text-[#090406]">
                                                        {prod.DESCRIPTION}
                                                    </p>
                                                </div>
                                            </td>
                                            <td className="text-sm font-normal text-[#090406] py-4 px-7">
                                                {`${prod.DIAMETER !== null ? `${prod.DIAMETER}mm` : ''}`}
                                                {`${prod.LENGTH !== null && prod.DIAMETER ? 'x' : ''}`}
                                                {`${prod.LENGTH !== null ? `${prod.LENGTH}mm` : ''}`}
                                                {prod.LENGTH === null && prod.DIAMETER === null ? '-' : ''}
                                            </td>
                                            <td className="text-sm font-normal text-[#090406] py-4 px-7">
                                                {prod.PRIMARY_UOM_CODE}
                                            </td>
                                            <td className="text-sm font-normal text-end text-[#090406] py-4 px-7">
                                                {PriceHandler(prod.LIST_PRICE)}
                                            </td>
                                            <td className="text-sm font-normal text-[#090406] py-4 px-7">
                                                {prod.MAIN_CATEGORY}
                                            </td>
                                            <td className="text-sm font-normal text-[#090406] py-4 px-7">
                                                {prod.SEGMENT2}
                                            </td>
                                            <td className="text-sm font-normal text-[#090406] py-4 px-7">
                                                {prod.SEGMENT3}
                                            </td>
                                            <td className="text-sm font-normal text-[#090406] py-4 px-7">
                                                {prod.SEGMENT4}
                                            </td>
                                            <td className="text-sm font-normal text-[#090406] py-4 px-7">
                                                {prod.AWS_CLASSIFICATION || <div className="pl-[60px]">-</div>}
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    )}
                </div>
            )}
            {products && products.length > 0 && (
                <Pagination
                    handlePageClick={handlePageClick}
                    totalPage={totalPage}
                    List={alldata}
                    currentPage={currentPage}
                />
            )}
            {emptyData && (
                <EmptyScreen
                    search="yes"
                    text="no Product PriceList"
                    buttonRequired={false}
                    all={filterQuery.search !== '' ? 'under searched term' : 'found'}
                />
            )}
        </div>
    );
}

export default ProductPriceList;
